import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { pathFinder } from '../ui/pathFinder-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { IMachine } from '../machines/machines'
import { distance } from '../lib/distance-sidecar'

export function createTask_goToMachine(
  i: number,
  j: number,
  filter: (m: IMachine) => boolean,
  allowNextTo: boolean = false,
): ITask {
  let t = jobs._createTask(i, j, 'go-to-machine', {
    machineFilter: filter,
    allowNextTo,
  })
  return t
}

export function runTask_goToMachine(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'go-to-machine')

  let m = jobLogger.assertReserved(job)

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  let f = task.machineFilter

  let mc = machines.findAtSpot(m.i, m.j, f)
  if (mc) {
    // Here!
    return jobLogger.succeedTask(job, task)
  }

  mc = machines.findClosestTo(m.i, m.j, f)
  if (!mc) {
    return jobLogger.failTask(job, task, 'no valid machine')
  }

  if (task.allowNextTo) {
    if (distance.isNextToIJ(m, mc)) {
      return jobLogger.succeedTask(job, task)
    }
  }

  // Find path to delivery spot!
  job.findPathId = pathFinder.findPath(
    m.i,
    m.j,
    mc.i,
    mc.j,
    m.isInsideShip,
    task.allowNextTo,
    (path) => {
      job.findPathId = 0
      jobLogger.assertTask(task)
      if (!path || path.length === 0) {
        return jobLogger.failTask(job, task, 'no path')
      }
      let mPath = jobLogger.assertReserved(job)
      monsters.setPath(mPath, path)
    },
  )
}
